import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-guard-list',
  templateUrl: './guard-list.component.html',
  styleUrls: ['./guard-list.component.css']
})
export class GuardListComponent implements OnInit {
    argType;

    argValue;

    public itemsListGuards: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadGuards(): Promise<void> {
        if (!!this.argType && !!this.argValue) {
            this.itemsListGuards = await this.datatask.Post(1649, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadGuards();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('guardList', {
//        templateUrl: 'views/components/views/guardList/guardList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'guardListService', function ($stateParams, guardListService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;

//            vm.model = {
//                itemsListGuards: []
//            };

//            async function loadGuards() {
//                vm.model.itemsListGuards = (await guardListService.listGuards({
//                    argtype: argType,
//                    argvalue: argValue
//                }));
//            }

//            vm.$onInit = function () {
//                loadGuards();
//            };
//        }]
//    });
//})();
